import React from 'react';
import Chart from "react-apexcharts";
import { chartTimeFormat } from "../../../Js/TimeAndDate";

const PieChart = (props) => {

    let chartSeries = [];
    let trainerReportData = props.pieChartData;

    const chartOptions = {
        labels: ['Presentation', 'Task', 'Assignment', 'Evaluation'],
        plotOptions: {
            pie: {
                donut: {
                    size: '50%',
                },
                customScale: 0.9
            }
        },
        legend: {
            position: 'bottom',
        }
    };
    let courseTime = chartTimeFormat(parseInt(trainerReportData[0].courseTime));
    let taskTime = chartTimeFormat(parseInt(trainerReportData[0].taskTime));
    let assiTime = chartTimeFormat(parseInt(trainerReportData[0].assiTime));
    let evalTime = chartTimeFormat(parseInt(trainerReportData[0].evalTime));
    chartSeries.push(courseTime, taskTime, assiTime, evalTime);

    return (
        <Chart
            options={chartOptions}
            series={chartSeries}
            type="pie"
            height={(props.chartHeight) ? props.chartHeight : 'auto'}
        />
    );
};
export default PieChart;